import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Button } from './ui/Button';
import { ShieldCheck, Clock, Gift, Check } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const results = ['Reducir el sobrepensamiento', 'Sentirte más tranquilo desde el día 1', 'Tener control emocional real', 'Saber qué hacer en momentos difíciles', 'Recuperar claridad mental'];
export function Pricing() {
  return <AnimatedSection id="pricing" className="bg-cream text-navy py-12 md:py-16" data-id="element-84">
      <div className="max-w-2xl mx-auto" data-id="element-85">
        <div className="bg-white rounded-3xl p-6 md:p-10 border-2 border-orange relative overflow-hidden text-center shadow-xl" data-id="element-86">
          <div className="absolute top-5 -right-10 bg-orange text-white font-bold py-1 px-10 transform rotate-45 text-xs shadow-md" data-id="element-87">
            60% OFF
          </div>

          <h2 className="text-2xl md:text-3xl font-heading font-bold mb-2 text-navy" data-id="element-88">
            💸 Oferta Especial — Solo Hoy
          </h2>

          <CountdownTimer hours={1} minutes={59} seconds={59} data-id="element-89" />

          {/* Quick results list */}
          <div className="text-left bg-cream rounded-xl p-5 mb-6" data-id="element-90">
            <p className="font-heading font-bold text-sm mb-3 text-navy-light" data-id="element-91">
              Con este kit vas a lograr:
            </p>
            <ul className="space-y-2" data-id="element-92">
              {results.map((r, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-93">
                  <Check size={16} className="text-orange shrink-0" data-id="element-94" />
                  <span data-id="element-95">{r}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-6" data-id="element-96">
            <p className="text-gray-400 text-base line-through" data-id="element-97">$49.990 ARS</p>
            <div className="flex justify-center items-baseline gap-2 mt-1" data-id="element-98">
              <span className="text-5xl md:text-6xl font-heading font-bold text-navy" data-id="element-99">
                $19.990
              </span>
              <span className="text-xl font-bold text-orange" data-id="element-100">ARS</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-orange/10 text-orange px-3 py-1 rounded-full font-bold text-sm mt-3" data-id="element-101">
              <Gift size={16} data-id="element-102" />
              <span data-id="element-103">Ahorrás $30.000</span>
            </div>
          </div>

          <Button href="https://checkout.tusbeneficios.shop/cart/50944196280553:1" className="w-full text-lg md:text-xl py-5 mb-6 shadow-[0_0_30px_rgba(232,131,58,0.3)]" data-id="element-104">
            👉 EMPEZÁ HOY — QUIERO MI KIT
          </Button>

          <div className="flex items-center gap-3 bg-green-50 rounded-xl p-4 mb-4 text-left border border-green-200" data-id="element-105">
            <ShieldCheck size={24} className="text-green-600 shrink-0" data-id="element-106" />
            <div data-id="element-107">
              <p className="font-bold text-sm text-green-800" data-id="element-108">
                Garantía "Cero Ansiedad al Comprar"
              </p>
              <p className="text-green-700 text-xs" data-id="element-109">
                Si no te ayuda, pedís reembolso. Sin preguntas.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-110">
            <Clock size={14} data-id="element-111" />
            <span data-id="element-112">Acceso por tiempo limitado</span>
            <span className="text-orange font-bold flex items-center gap-1" data-id="element-113">
              <span className="w-1.5 h-1.5 rounded-full bg-orange animate-ping" data-id="element-114"></span>
              Últimos cupos
            </span>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}